<template>
  <b-row>
    <b-col
      class="d-flex align-items-center flex-wrap mb-4"
      v-for="product in productsWithAdjustedPrice"
      :key="product.productId"
      cols="12"
      md="4"
    >
      <product-card
        style="width: 100%"
        :product="product"
        :isSelected="!!selectedProducts.some((p) => p.productId === product.productId)"
        :disabled="product.quantityStock <= 0"
        @update-price="updatePrice({ product, newPrice: $event })"
        @update-category="updateCategory({ product, newCategory: $event })"
        @update-attributes="updateAttributes({ product, newAttributes: $event })"
        @select-product="handleProductSelection(product)"
      />
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from 'vuex';

import ProductCard from './ProductCard.vue';

export default {
  name: 'IntegrateMercadoLivre',
  emits: ['update-price', 'select-product', 'update-details'],
  components: { ProductCard },
  props: {
    products: {
      type: Array,
      required: true,
      default: () => [],
    },
    selectedProducts: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  computed: {
    ...mapState(['dadosUsuario']),
      productsWithAdjustedPrice() {
      return this.products.map(product => ({
        ...product,
        priceSalesFormat1: product.priceSalesFormatNew || product.priceSalesFormat1,
      }));
    }
  },
  methods: {
    handleProductSelection(product) {
      this.$emit('select-product', this.mercadoLivreProductFactory(product));
    },
    updatePrice({ product, newPrice }) {
      this.$emit(
        'update-details',
        this.mercadoLivreProductFactory({
          ...product,
          priceSalesFormat1: newPrice,
        })
      );
    },
    updateCategory({ product, newCategory }) {
      this.$emit(
        'update-details',
        this.mercadoLivreProductFactory({
          ...product,
          categoryId: newCategory,
        })
      );
    },
    updateAttributes({ product, newAttributes }) {
      this.$emit(
        'update-details',
        this.mercadoLivreProductFactory({
          ...product,
          attributes: newAttributes,
        })
      );
    },
    mercadoLivreProductFactory(product) {
      return {
        productId: product.productId,
        price: product.priceSalesFormat1,
        categoryId: product.categoryId,
        attributes: product.attributes || [],
      };
    },
  },
};
</script>
